module.exports = __webpack_public_path__ + "fonts/font.bd8c115b.woff2";